import { useUser } from '@/hooks/use-user';
import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { Loader2 } from 'lucide-react';

interface AuthGuardProps {
  children: React.ReactNode;
}

export function AuthGuard({ children }: AuthGuardProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, isLoading } = useUser();

  useEffect(() => {
    if (!isLoading && !user) {
      const from = location.pathname + location.search + location.hash;
      // Redirect to login but save the current location to redirect back after login
      navigate(`/login?redirect=${encodeURIComponent(from)}`, {
        replace: true,
        state: { from },
      });
    }
  }, [isLoading, user, navigate, location]);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="flex flex-col items-center gap-4">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
          <p className="text-sm text-muted-foreground animate-pulse">Verifying access...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return null;
  }

  return <>{children}</>;
}
